import React from 'react';
import { connect } from 'react-redux';
import { findDeep } from '../util';
import OptionsTitlebar from './OptionsTitlebar';
import OptionsEditor from './OptionsEditor';

import styles from '../../../../stylesheet/css/header-builder/options.css';

export const Options = (props) => {
  return (
    <div className={styles.options}>
      <OptionsTitlebar {...props} />
      <OptionsEditor {...props} />
    </div>
  );
};

const mapStateToProps = (state) => {
  const { model } = state,
        { activeDevice: device } = model,
        deviceModel = model[device].present,
        { highlightedId } = deviceModel;

  const highlightedElementModel = highlightedId === ''
      ? deviceModel
      : findDeep(deviceModel, t => t && t.id === highlightedId);

  return {
    device,
    highlightedElementModel: highlightedElementModel || deviceModel
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Options);



// WEBPACK FOOTER //
// ./app/header-builder/components/Options.js